import LocationPinIcon from "@mui/icons-material/LocationPin";
import { Button, darken } from "@mui/material";
import { t } from "i18next";
import L from "leaflet";
import { useMap } from "react-leaflet";
import { useNavigate } from "react-router-dom";
import { iresoftColors } from "../../../theme/ireColors";
import { handleCurrentlyReading } from "../../../utils/utils";
import { errorToast } from "../Toastify/Toastify";

const LocateButton: React.FC = () => {
  const map = useMap();
  const navigate = useNavigate();

  const handleLocate = () => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        map.setView([latitude, longitude], 13);

        const marker = L.marker([latitude, longitude]).addTo(map);
        marker.bindPopup(t("pages.welcome.map.youAreHere")).openPopup();
        marker.on("click", () => {
          handleCurrentlyReading(navigate);
        });
      },
      (error) => {
        console.error(error);
        errorToast(t("pages.welcome.map.error.cannotFindLocation"));
      }
    );
  };

  return (
    <Button
      variant="contained"
      onClick={handleLocate}
      sx={{
        position: "absolute",
        bottom: 30,
        left: { xs: 10, sm: 50 },
        zIndex: 1000,
        borderRadius: 4,
        p: { xs: 1, sm: 1.5 },
        px: { xs: 1, sm: 2 },
        minWidth: { xs: 30, sm: 50 },
        minHeight: { xs: 30, sm: 40 },
        boxShadow: "0 4px 12px rgba(0,0,0,0.35)",
        backgroundColor: iresoftColors.iresoftRed,
        color: iresoftColors.white,
        "&:hover": {
          backgroundColor: darken(iresoftColors.iresoftRed, 0.15),
        },
      }}
    >
      <LocationPinIcon fontSize="small" sx={{ fontSize: { xs: 16, sm: 20 } }} />
    </Button>
  );
};

export default LocateButton;
